import React, { Component } from 'react';
import { Button } from 'reactstrap';

class RadioButtonGroup extends Component {
  constructor (props) {
    super(props);

    this.state = {
        selected: this.toYesNo(props.initialValue)
    };

    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
  }

  toYesNo = value => {
      if(value === true) {
          return 'Yes';
      } else if (value === false) {
          return 'No';
      } else {
          return '';
      }
  }

  onRadioBtnClick = e => {
      let value = e.target.value;
      this.setState({ selected: value });
      this.props.handleChange(e);
  }

  render() {
    return (
        <div className='form-group' key={this.props.name}>
            <div className="control-label">
                <h5>
                    {this.props.title}&nbsp;&nbsp;
                    <a style={{fontSize: '11px'}} href={this.props.link} target='_blank' rel='noopener noreferrer'>Learn more about {this.props.name} compliance attestation</a>
                </h5>
            </div>
            {this.props.options.map(option => {
                return (
                        <Button
                            key={this.props.name + option}
                            style={{margin: '0px 10px 0px 10px'}}
                            color={this.state.selected === option ? 'primary' : 'secondary'}
                            id={this.props.name + option}
                            value={option}
                            name={this.props.name}
                            onClick={this.onRadioBtnClick}
                            disabled={this.props.disabled}
                        >
                            {option}
                        </Button>
                );
            })}
      </div>
    );
  }
}

export default RadioButtonGroup;